export const environment = {
  production: true,
  api: 'https://apiselecao.vitoria.es.gov.br/api',
  timeLogout: 3599,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts